import { apiClient } from './client';
import { endpoints } from './endpoints';

export const deleteWbTicket = (encId: string) =>
  apiClient.delete(endpoints.wb.ticket(encId));
